export default "__VITE_ASSET__B1Bh4bs8__"